module.exports = __webpack_public_path__ + "img/owee-logo.2f615758.svg";